export enum IconsEnum {
  Vrtic = 'Vrtic',
  UcenickiDom = 'UcenickiDom',
  SrednjaSkola = 'SrednjaSkola',
  OsnovnaSkola = 'OsnovnaSkola',
  ObrazovanjeOdraslih = 'ObrazovanjeOdraslih',
  SRDM = 'SRDM',
  eDnevnik = 'eDnevnik',
  Potvrde = 'Potvrde'
}